import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
} from "@mui/material";
import TAGlogo from "assets/images/TAGlogo.svg";
import qmark from "assets/images/qmark.png";

function Unauthorized() {
  return (
    <div className="b-unauthorized-container">
      <Box className="b-unauthorized-container__box">
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <img
              className="b-unauthorized-container__logo"
              src={TAGlogo}
              alt="Error in loading"
            />
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <div
        className="b-unauthorized-container__body"
        id="login-page-background"
      >
        <Grid
          container
          spacing={2}
          direction="column"
          alignItems="center"
          justify="center"
          className="b-unauthorized-container__alignment"
        >
          <Grid item xs={12} className="b-unauthorized-container__card">
            <Card className="b-unauthorized-container__cardHead">
              <CardContent className="b-unauthorized-container__content">
                <Typography className="login-card-header">
                  <div>
                    <h2 className="b-unauthorized-container__content-text">
                      You are Unauthorized!
                    </h2>
                  </div>
                </Typography>
              </CardContent>
              <CardContent>
                <img
                  className="b-unauthorized-container__image"
                  src={qmark}
                  alt=""
                />
                <div className="b-unauthorized-container__div-text">
                  <span className="font-bold b-unauthorized-container__span-text">
                    Please contact TAG.
                  </span>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default Unauthorized;
